export var SDK_VERSION = '6.19.7';
//# sourceMappingURL=version.js.map